import React, { useMemo } from 'react';
import Moment from 'react-moment';
import PropTypes from 'prop-types';
import { Typography, makeStyles, Grid, Tooltip, useMediaQuery } from '@material-ui/core';
import { Description } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  errorContainer: {
    margin: '8px 0'
  },
  errorIcon: {
    color: '#B00020',
    verticalAlign: 'middle',
    marginRight: 12
  },
  errorMessage: {
    fontSize: 12,
    textTransform: 'uppercase',
    color: '#B00020',
    verticalAlign: 'middle'
  },
  tooltipWidthDesktop: {
    maxWidth: 500
  },
  tooltipWidthMobile: {
    maxWidth: 300
  }
});

const CertificateDescription = (props) => {
  const { document, showImage } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width: 500px)');

  const delay = 200;
  const touchDelay = 300;
  const placement = 'bottom-start';
  const tooltipWitdh = (isMobile ? classes.tooltipWidthMobile : classes.tooltipWidthDesktop);
  const sentTo = useMemo(() => {
    const flow = JSON.parse(document.flow || '{}');
    const recipients = flow && flow.files && flow.files[0].metadata && flow.files[0] && flow.files[0].metadata.recipients;
    const sentTo = recipients && recipients.map(r => r.email || r.phoneNumber);
    return sentTo;
  }, [document.flows]);

  return (
    <Grid
      container
      wrap='nowrap'
    >
      {showImage && <Description style={{ fontSize: 75, paddingRight: 15 }} />}
      <div style={{ overflow: 'hidden' }}>
        <Tooltip title={document.name} enterDelay={delay} enterTouchDelay={touchDelay} placement={placement} classes={{ tooltip: tooltipWitdh }}>
          <Typography variant='subtitle1' style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} >
            {document.name}
          </Typography>
        </Tooltip>
        <Tooltip title={sentTo} enterDelay={delay} enterTouchDelay={touchDelay} placement={placement} classes={{ tooltip: tooltipWitdh }}>
          <Typography variant='body2' style={{ marginTop: 5, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
            {t('certificate:list:sentTo')} {sentTo}
          </Typography>
        </Tooltip>
        <Typography variant='body2'>
          <Moment format='DD/MM/YYYY HH:mm:ss'>{document.updatedAt}</Moment>
        </Typography>
      </div>
    </Grid>
  );
};

CertificateDescription.propTypes = {
  document: PropTypes.object.isRequired,
  showImage: PropTypes.bool
};

export default CertificateDescription;
